export const TM_BACKGROUND = 'darkslategray';
export const OPTIONS_KEY = 'TM OPTIONS';
export const HELPED_KEY = 'TM HELPED';
export const TM_BLUE = 'rgb(80, 80, 204)';
export const TM_ORANGE = 'darkorange';
export const CLEAR_LEVEL = 'TM CLEAR LEVEL';
export const TRIOMINOS_PER_LEVEL = 25;
export const TRANSITION_DURATION = 500;
export const YOUTUBE_TM = 'https://youtu.be/Q95NWHZXZyY';
